<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="col-content">
  <div class="header-content">
    <div class="heading">{{adheridoInfo.razonSocial}}</div>
  </div>
  <div class="button-group">
    <button style="float:right" type="button" (click)="addPrevisionModal()" class="btn btn-primary"
      *ngIf="canAccessCreate()">NUEVA PREVISIÓN</button>
  </div>
  <form [formGroup]="formGroup" style="margin-top:20px">
    <div class="row-fields">
      <div class="field field-25">
        <label for="anio">Año</label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="anio" id="anio" placeholder="Año" (selectionChange)="anioSelected()">
            <mat-option [value]="null">-- Todos --</mat-option>
            <mat-option *ngFor="let anio of anios" [value]="anio?.id">
              {{anio?.id}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div style="border: 1px solid #e4e4e4; padding:20px;">
      <div class="row-fields">
        <div class="field field-100">
          <label for="codigoLer">Código LER y descripción de ENVALORA<em
            *ngIf="formGroup.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
            style="color: #B80F61;" matTooltip="Envase de tipo peligroso"></em></label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination class="lib-ge-select" [endPointFilter]="codigosLerEndpoint"
              [updateList]="updateList" [descripcion]="getLerDescription" [disabled]="flagDisabledForm"
              [formControlNameSelect]="getFormControl('codigoLer')" [objQueryName]="getObjectQuery"
              [placeHolder]="'-- Código LER y descripción de ENVALORA --'" [customClass]="rightHolder('codigoLer')">
            </lib-ge-select-pagination>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-33">
          <label for="nima"><br>NIMA del gestor</label>
          <mat-form-field appearance="outline">
            <input formControlName="nima" id="nima" matInput type="text" placeholder="NIMA del gestor" maxlength="10" (input)="onInput('nima', $event)">
            <mat-error *ngIf="controlHasError('nima', 'pattern')">Formato incorrecto</mat-error>
            <mat-error *ngIf="controlHasError( 'nima', 'maxlength')">Máximo 10 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="field field-33" style="margin-top:22px;">
          <label for="suministraInfo">¿Quién suministra información de gestión?</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="suministraInfo" id="suministraInfo"
              placeholder="¿Quién suministra información de gestión?">
              <mat-option [value]="null">-- Todos --</mat-option>
              <mat-option *ngFor="let el of suministraInfoList" [value]="el?.id">
                {{el?.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field field-33">
          <div class="button-group" style="margin-top:46px;">
            <button style="float:right" type="button" (click)="buscarPrevision()" class="btn btn-primary">Buscar</button>
          </div>
        </div>
      </div>
    </div>
  </form>


</div>
<div class="mt-3" style="display:flex;justify-content:flex-end;gap:8px;align-items:center;white-space:nowrap;">
  <div class="action-buttons" style="display:flex;gap:8px;align-items:center;">
    <button type="button" (click)="import()" class="btn btn-primary me-2" *ngIf="mostrarImportar">Importar</button>
    <button type="button" (click)="export()" class="btn btn-primary" [disabled]="exporting">Exportar</button>
  </div>
</div>
<div class="datatable-container table-responsive">
  <lib-ge-table [headArray]="headArray" [gridArray]="grid" (actionButton)="action($event)" [sortByClient]="true">
  </lib-ge-table>
</div>
